// ===== Styles =====
import {makeStyles} from "@material-ui/core/styles";
import {Colors} from "../../../styles/Colors";
import {Agent} from "../../../store/types/AiAgent";
import {ChangeDirtyStateDetailsTab} from "../../../views/Extensions/ExtensionDetails/utils";

export const useStyles = makeStyles(() => ({
    root: {
        maxWidth: 1040,
        paddingLeft: 16,
    },

    container:{
      width:'fit-content'
    },

    skeleton: {
        width: '100%',
    },
    skeletonField: {
        width: 320,
        display: 'flex',
        flexDirection: 'column',
    },
    skeletonButton: {
        width: 220,
    },

    swicher: {
        marginBottom: 2,
        paddingTop: 22,
        height: 'auto',
        color: Colors.Gray7,
    },
    rowContainer: {
        flex: 1,
        display: 'flex',
        paddingTop: 16,
        paddingBottom: 24,
        alignItems: 'flex-start',
        '& > :first-child': {
            marginRight: 32,
        },
        '&:last-of-type': {
            paddingBottom: 0,
        },
    },

    input: {
        width: 320
    },

    buttonStyle: {}
}));
// ===== Types and Interfaces =====
export type AiFormType = {
    aiAgent: Agent | null;
    aiEnabled: boolean;
};

export interface AiFormInterface {
    emailIsPresent? : boolean | null;
    countryIsPresent? : boolean | null;
    adapterAvailable?: boolean;
    // init-session ultimately failed (after the saga's retry) — locks the toggle.
    initSessionFailed?: boolean;
    isInitialLoading?: boolean;
    onAiEnabledChange?: (enabled: boolean) => void;
    handleSubmitForm?: (formData: Partial<AiFormType>) => void;
    handleDirtyChange?: ChangeDirtyStateDetailsTab;
    handleSetSubmitFunc?: (funcName: string, func: () => void) => void;
    handleSetIsValidFunc?: (funcName: string, func: () => boolean) => void;
}
